/**
 * Microfrontend Configuration
 * 
 * This file defines the mapping between routes and microfrontend bundles.
 * Each microfrontend should expose a default export that is a React component.
 * 
 * The bundleUrl can be:
 * - A local path during development
 * - An S3/CDN URL in production (e.g., https://cdn.example.com/app1/bundle.js)
 * 
 * Permissions:
 * - requiredPermissions: Array of Cognito group names or custom permissions
 * - If empty array, app is available to all authenticated users
 * - If user has ANY of the required permissions, they can access the app
 */

export type MicrofrontendType = "iframe" | "federation" | "esm";

export interface MicrofrontendConfig {
  id: string;
  name: string;
  route: string;
  bundleUrl: string;
  enabled: boolean;
  type?: MicrofrontendType; // "iframe" for normal apps, "federation" for module federation, "esm" for ES modules
  description?: string;
  requiredPermissions?: string[]; // Cognito groups or custom permissions
  icon?: string; // Optional icon name
  remoteName?: string;   // Only needed for federation type
  exposedModule?: string; // Only needed for federation type
  appName?: string;
}

export const microfrontends: MicrofrontendConfig[] = [
  {
    id: "chatbot",
    name: "Chatbot App",
    route: "/chatbot",
    type: "federation", // Normal app — just embed it via iframe
    bundleUrl: import.meta.env.VITE_CHATBOT_BUNDLE_URL || "http://localhost:3001",
    enabled: true,
    description: "AI Chatbot application",
    requiredPermissions: ["chatbot-access"],
  },
  {
    id: "userflow",
    name: "AI Userflow App",
    route: "/userflow",
    bundleUrl: import.meta.env.VITE_USERFLOW_BUNDLE_URL || "http://localhost:3002/remoteEntry.js",
    enabled: true,
    description: "AI Userflow application",
    requiredPermissions: ["userflow-access"], // Only users with this permission can see this app
  },
  // Example: App available to all authenticated users (no permissions required)
  // {
  //   id: "public-app",
  //   name: "Public App",
  //   route: "/public-app",
  //   bundleUrl: import.meta.env.VITE_PUBLIC_APP_BUNDLE_URL || "http://localhost:3003/remoteEntry.js",
  //   enabled: true,
  //   description: "Public application",
  //   requiredPermissions: [], // Empty array = available to all authenticated users
  // },
  // Example: App requiring multiple permissions (user needs at least one)
  // {
  //   id: "admin-app",
  //   name: "Admin App",
  //   route: "/admin-app",
  //   bundleUrl: import.meta.env.VITE_ADMIN_APP_BUNDLE_URL || "http://localhost:3004/remoteEntry.js",
  //   enabled: true,
  //   description: "Admin application",
  //   requiredPermissions: ["admin", "super-admin"], // User needs admin OR super-admin
  // },
];

/**
 * Get microfrontend config by route
 */
export function getMicrofrontendByRoute(route: string,applications:any[]): MicrofrontendConfig | undefined {
  const config = applications.find((mf) => route.startsWith(mf.route))||{};
  return config;
}

/**
 * Get all enabled microfrontends
 */
export function getEnabledMicrofrontends(): MicrofrontendConfig[] {
  return microfrontends.filter((mf) => mf.enabled);
}

/**
 * Get microfrontends filtered by user permissions
 * @param userPermissions - Array of permissions/groups the user has
 * @returns Filtered list of microfrontends the user can access
 */
export function getMicrofrontendsByPermissions(userPermissions: string[]): MicrofrontendConfig[] {
  return getEnabledMicrofrontends().filter((mf) => {
    // If no permissions required, app is available to all authenticated users
    // if (!mf.requiredPermissions || mf.requiredPermissions.length === 0) {
    //   return true;
    // }
    
    // // User needs at least one of the required permissions
    // return mf.requiredPermissions.some((perm) => userPermissions.includes(perm));
    return true;
  });
}
